import { useState } from "react";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";
import { PosterEditor } from "PosterEditor/PosterEditor";
import { useProjectStore } from "entity-store/project-store/use-project-store";
import { useEffect } from "react";
import { usePaths } from "BEDROCK/paths";
import { getIDFromCurrentURL } from "PosterEditor/utils/url-parsing";
import { ThreeDot } from "react-loading-indicators";
import styles from "./process-order.module.css";

interface ProcessOrderProps {}

export const ProcessOrder = (props: ProcessOrderProps) => {
  const { navigateTo, checkout: checkoutPath } = usePaths();

  const { loadProject } = useProjectStore();
  const [isLoading, setIsLoading] = useState(true);

  const { pay: continueToCheckout } = useCheckout();

  const [projectID, setProjectID] = useState<string | null>(null);

  useEffect(() => {
    const projectID = getIDFromCurrentURL();
    if (projectID) {
      const project = loadProject(projectID);
      if (project && project.isRendered) {
        // continueToCheckout()
      } else {
        setProjectID(projectID);
        setIsLoading(false);
      }
    }
  }, []);

  if (isLoading || !projectID) {
    return (
      <div className={styles.loadingContainer}>
        <ThreeDot color="lightGray" size="medium" text="" textColor="" />
      </div>
    );
  }

  return <PosterEditor projectID={projectID} contextType="rendering" />;
};
